module.exports = __webpack_public_path__ + "img/03.bb40abd7.svg";